import script from "./ButtonIconAccentPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonIconAccentPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonIconAccentPrimary.vue?vue&type=style&index=0&id=1550491f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1550491f"]])

export default __exports__